import { render, staticRenderFns } from "./AccProductReactionDeleteAction.vue?vue&type=template&id=44d698b0"
import script from "./AccProductReactionDeleteAction.vue?vue&type=script&lang=js"
export * from "./AccProductReactionDeleteAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports